export default __webpack_public_path__ + "static/media/card-front.ad91175e.svg";